import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'components/Slider';
import volumeZeroIcon from 'assets/icons/volume_0.svg';
import volumeLowIcon from 'assets/icons/volume_26_50.svg';
import volumeHighIcon from 'assets/icons/volume_51_100.svg';
import VolumeSeekerStyled from './styles/VolumeSeekerStyled';
import { isHasDesktopHover } from '../../utils/isMobile';

class VolumeSeeker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentTime: 0,
      seekerHover: false,
      volumeBeforeMute: props.isMobile || !isHasDesktopHover ? 100 : 0,
    };
  }

  handleVolumeClick = () => {
    const { muted, unMute, mute, setVolume, volume, isMobile } = this.props;
    const volumeBeforeMute = this.state.volumeBeforeMute;

    if (muted) {
      unMute();
      if (volumeBeforeMute === 0) setVolume(60);
      if (isMobile) setVolume(volumeBeforeMute);
    } else if (!muted && volume === 0) {
      // устанавливаем последний уровень громкость после перетягивания слайдера громкости в 0
      // и последующего анмута кнопкой
      setVolume(volumeBeforeMute);
    } else {
      mute();
    }
  };

  iconName = () => {
    // change volume icon
    let icon = '';
    if (this.props.muted || this.props.volume === 0) {
      icon = volumeZeroIcon;
    } else if (this.props.volume <= 50) {
      icon = volumeLowIcon;
    } else {
      icon = volumeHighIcon;
    }

    return icon;
  };

  onPointerDown = () => {
    const volume = this.props.volume;
    if (volume !== 0) {
      this.setState({
        volumeBeforeMute: volume,
      });
    }
  };

  render() {
    const {
      volume,
      setVolume,
      getSeeking,
      isMobile,
      muted,
      isBlocked,
      connectColor,
      iconColor,
      hoverColor,
    } = this.props;

    return (
      <VolumeSeekerStyled
        isBlocked={isBlocked}
        onPointerDown={this.onPointerDown}
      >
        <Slider
          max={100}
          currentTime={muted ? 0 : volume}
          progress={100}
          onChange={setVolume}
          drawThumbnail={false}
          offset={0}
          secondsPrefix="00:00:"
          minutesPrefix="00:"
          width={80}
          type="volume"
          icon={this.iconName()}
          onVolumeIconClick={this.handleVolumeClick}
          getSeeking={getSeeking}
          isMobile={isMobile}
          connectColor={connectColor}
          volumeIconColor={iconColor}
          volumeHoverColor={hoverColor}
        />
      </VolumeSeekerStyled>
    );
  }
}

VolumeSeeker.propTypes = {
  muted: PropTypes.bool.isRequired,
  volume: PropTypes.number.isRequired,
  mute: PropTypes.func.isRequired,
  unMute: PropTypes.func.isRequired,
  setVolume: PropTypes.func.isRequired,
  getSeeking: PropTypes.func,
  isMobile: PropTypes.bool,
  isBlocked: PropTypes.bool,
  connectColor: PropTypes.string,
};

VolumeSeeker.defaultProps = {
  getSeeking: Function.prototype,
  isMobile: false,
  isBlocked: false,
  connectColor: '',
};

export default VolumeSeeker;
